module.exports = __webpack_public_path__ + "static/media/map-outline-01.7818a806.svg";